import { useState } from "react";

import { AlertBanner } from "../feedback/AlertBanner";
import { EarTagView, useTagDisplayPreferences } from "./EarTag";
import {
  EAR_TAG_EXAMPLE,
  TAG_DISPLAY_FORMATS,
  TAG_DISPLAY_FORMAT_LABELS,
  type TagDisplayFormat,
  type TagDisplayPreferences,
} from "../../lib/tagDisplay";

export function TagDisplaySettings() {
  const { preferences, save } = useTagDisplayPreferences();
  const [error, setError] = useState<string | null>(null);
  const [info, setInfo] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function persist(next: TagDisplayPreferences) {
    setBusy(true);
    setError(null);
    setInfo(null);
    try {
      await save(next);
      setInfo("Zapisano format numerów kolczyków.");
    } catch (err) {
      setError(err instanceof Error ? err.message : "Nie udało się zapisać formatu kolczyków.");
    } finally {
      setBusy(false);
    }
  }

  function onFormat(display_format: TagDisplayFormat) {
    if (display_format === preferences.display_format) {
      return;
    }
    void persist({ ...preferences, display_format });
  }

  function onBold(bold_last_digit: boolean) {
    if (bold_last_digit === preferences.bold_last_digit) {
      return;
    }
    void persist({ ...preferences, bold_last_digit });
  }

  return (
    <section className="panel settings-panel" data-testid="settings-tag-display">
      <div className="panel__header">
        <div>
          <h2 className="panel__title">Wygląd numerów kolczyków</h2>
          <p className="muted">
            Numery zaczynające się od PL1000 są pokazywane w wybranym układzie na całym koncie.
            Zapis w bazie zostaje bez spacji.
          </p>
        </div>
      </div>
      <AlertBanner variant="error" message={error} onDismiss={() => setError(null)} />
      <AlertBanner variant="ok" message={info} onDismiss={() => setInfo(null)} />
      <div className="settings-tag-formats" role="radiogroup" aria-label="Format numeru kolczyka">
        {TAG_DISPLAY_FORMATS.map((format) => {
          const selected = preferences.display_format === format;
          return (
            <label
              key={format}
              className={selected ? "settings-tag-format is-selected" : "settings-tag-format"}
            >
              <input
                type="radio"
                name="tag-display-format"
                value={format}
                checked={selected}
                disabled={busy}
                data-testid={`settings-tag-format-${format}`}
                onChange={() => onFormat(format)}
              />
              <span className="settings-tag-format__label">{TAG_DISPLAY_FORMAT_LABELS[format]}</span>
              <span className="settings-tag-format__sample">
                <EarTagView
                  value={EAR_TAG_EXAMPLE}
                  format={format}
                  boldLast={preferences.bold_last_digit}
                />
              </span>
            </label>
          );
        })}
      </div>
      <label className="list__check">
        <input
          type="checkbox"
          checked={preferences.bold_last_digit}
          disabled={busy}
          data-testid="settings-tag-bold-last"
          onChange={(event) => onBold(event.target.checked)}
        />
        <span>Powiększ ostatnią cyfrę</span>
      </label>
    </section>
  );
}
